import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import IdNameModel from "../../../models/common/IdNameModel";
import TagsInputModel from "../../../models/common/TagsInputModel";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import dateUtils from "../../../utils/date-utils";
import InterviewerSchedulesRequestModel from "../../../models/interviewer/request/InterviewerSchedulesRequestModel";
import InterviewerSchedulesModel from "../../../models/interviewer/response/InterviewerSchedulesModel";
import InterviewerScheduleGridComponent from "./InterviewerScheduleGridComponent";
import InterviewerScheduleSearchComponent from "./InterviewerScheduleSearchComponent";
import modalUtils from "../../../utils/modal-utils";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { TimeSlotsAutocomplete } from "./TimeSlotsAutoComplete";
import { Box, Button } from "@mui/material";

interface InterviewerScheduleProps {
    tileSlotsList: IdNameModel[];
}

const InterviewerScheduleComponent = (props: InterviewerScheduleProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    let tagsinputList: TagsInputModel[] = props.tileSlotsList.map((item) => {
        return { id: item.id.toString(), text: item.name }
    })
    const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(null);
    const [timeslotsTags, setTimeslotsTags] = useState<TagsInputModel[]>(tagsinputList);
    const [timeslotsSelected, setTimeslotsSelected] = useState<TagsInputModel[]>([]);
    const [interviewerSchedules, setInterviewerSchedules] = useState<InterviewerSchedulesModel>();
    const [refreshInterviewerScheduleGrid, setRefreshInterviewerScheduleGrid] = useState<number>(2);

    const handleDelete = (i: number) => {
        setTimeslotsSelected(timeslotsSelected.filter((tag, index) => index !== i));
    };

    const handleAddition = (tag: TagsInputModel) => {
        setTimeslotsSelected([...timeslotsSelected, tag]);
    };

    const handleDrag = (tag: TagsInputModel, currPos: any, newPos: any) => {
        const newTags = timeslotsSelected.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        setTimeslotsSelected(newTags);
    };

    const handleTagClick = (index: any) => {
        //console.log('The tag at index ' + index + ' was clicked');
    };

    const saveSchedule = () => {
        if (scheduleDate === null || timeslotsSelected.length < 1) {
            toasterUtils.showWarning("Please Select Date and TimeSlots.");
        } else {
            var timslotsSaveList: InterviewerSchedulesRequestModel[] = [];
            if (loggedInUser) {
                var objTimeSlot: InterviewerSchedulesRequestModel = {
                    interviewerId: loggedInUser.profileId,
                    startDate: dateUtils.getFormattedDateFromDate(scheduleDate ? scheduleDate.toDate().toISOString() : ""),
                    endDate: dateUtils.getFormattedDateFromDate(scheduleDate ? scheduleDate.toDate().toISOString() : ""),
                    timeSlotIds: timeslotsSelected.map(x => Number(x.id)),
                    blockSchedule: false
                }
                timslotsSaveList.push(objTimeSlot);
            }
            if (timslotsSaveList.length > 0) {
                modalUtils.showLoader();
                InterviewerService.saveInterviewerSchedule(timslotsSaveList).then((res) => {
                    modalUtils.closeModal();
                    if (!res.isSuccess || res.errorMessages.length > 0) {
                        toasterUtils.showError(res.errorMessages.toString());
                        return;
                    }
                    toasterUtils.showSuccess(res.informationMessages.toString());
                    if (loggedInUser) {
                        getInterviewerSchedule(loggedInUser.profileId, scheduleDate ? scheduleDate.toDate().toISOString() : "");
                    }
                }).catch((error) => {
                    modalUtils.closeModal();
                    toasterUtils.showError(error);
                });
            }
        }
    };

    const clearSchedule = () => {
        setScheduleDate(null);
        setTimeslotsSelected([]);
        setRefreshInterviewerScheduleGrid(2);
    };

    const getInterviewerSchedule = (interviewerId: string, date: string) => {
        setRefreshInterviewerScheduleGrid(2);
        modalUtils.showLoader();
        InterviewerService.getInterviewerSchedules(interviewerId, dateUtils.getFormattedDateFromDate(date)).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewerSchedules(res.data);
            setRefreshInterviewerScheduleGrid(refreshInterviewerScheduleGrid * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <div>
        <div className="card card-white">
            <div className="card-title">Interview Set Schedule </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-4">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date"
                                value={scheduleDate}
                                onChange={(newValue) => setScheduleDate(newValue)}
                                format="YYYY-MMM-DD"
                                minDate={dayjs()}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        margin: "normal",
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="col-md-4">
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <TimeSlotsAutocomplete
                                options={timeslotsTags}
                                value={timeslotsSelected}
                                onAdd={(tag) => handleAddition(tag)}
                                onDelete={(index) => handleDelete(index)}
                                onChipClick={(index) => handleTagClick(index)}
                                placeholder="Click here to Add Time Slots"
                            />
                        </Box>
                    </div>
                    <div className="col-md-4">
                        <Button variant="contained" color="success" type="submit" disabled={scheduleDate === null || timeslotsSelected.length < 1} onClick={() => saveSchedule()} sx={{ mt: 2, ml: 2 }}>
                            Save
                        </Button>
                        <Button variant="contained" color="error" type="button" onClick={() => clearSchedule()} sx={{ mt: 2, ml: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-8">
                        <Button variant="contained" color="success" type="submit" disabled={scheduleDate === null || timeslotsSelected.length < 1} onClick={() => saveSchedule()} sx={{ mt: 2, ml: 2 }}>
                            Save
                        </Button>
                        <Button variant="contained" color="error" type="button" onClick={() => clearSchedule()} sx={{ mt: 2, ml: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div> */}
                <div className="row">
                    {interviewerSchedules && refreshInterviewerScheduleGrid != 2 &&
                        <InterviewerScheduleGridComponent
                            key={refreshInterviewerScheduleGrid}
                            interviewerSchedule={interviewerSchedules} />
                    }
                </div>
                
            </div> 
        </div>
        <div className="card card-white">
            <div className="card-title">Interview Schedule Search </div>
            <div className="card-body">
                <div className="row">
                    <InterviewerScheduleSearchComponent />
                </div>
            </div>
        </div>
        </div>
    );
};
export default InterviewerScheduleComponent;